import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const SupabaseCallback: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log('Handling Supabase auth callback');
        console.log('Current URL:', window.location.href);
        console.log('Hash:', window.location.hash);
        console.log('Search:', window.location.search);

        // Let Supabase handle the auth callback
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Error getting session:', error);
          setError(`Authentication failed: ${error.message}`);
          setLoading(false);
          return;
        }

        if (data.session) {
          console.log('Session found, redirecting to reset password');
          navigate('/reset-password');
        } else {
          console.log('No session found, checking for auth state changes');
          
          // Listen for auth state changes
          const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            console.log('Auth state change:', event, session);
            if (event === 'SIGNED_IN' && session) {
              console.log('User signed in, redirecting to reset password');
              navigate('/reset-password');
            } else if (event === 'SIGNED_OUT') {
              console.log('User signed out, redirecting to login');
              navigate('/login');
            }
          });

          // Set a timeout to handle cases where auth state doesn't change
          setTimeout(() => {
            subscription.unsubscribe();
            if (loading) {
              setError('Authentication timeout. Please try again.');
              setLoading(false);
            }
          }, 10000);

          return () => {
            subscription.unsubscribe();
          };
        }
      } catch (error) {
        console.error('Error in auth callback:', error);
        setError(`An error occurred: ${error instanceof Error ? error.message : 'Unknown error'}`);
        setLoading(false);
      }
    };

    handleAuthCallback();
  }, [navigate, loading]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Processing authentication...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-lg font-medium text-gray-900 mb-2">Authentication Failed</h2>
            <p className="text-sm text-gray-600 mb-4">{error}</p>
            <button
              onClick={() => navigate('/forgot-password')}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SupabaseCallback;
